import React from 'react';
import styles from "../styles/Login.module.css";

const PersonalDataPolicy = () => (
<ul className={styles.ul}>
    <li>
      <strong>제1조 (개인정보의 수집 및 이용 목적)</strong>
      <ol>
        <li>온길은 다음과 같은 목적을 위해 개인정보를 수집 및 이용합니다.</li>
        <li>회원가입 및 관리: 본인 확인, 계정 관리, 서비스 이용 확인</li>
        <li>서비스 제공: 맞춤형 서비스 제공, 고객 지원, 결제 및 정산</li>
        <li>보안 및 운영: 서비스 이용 기록 관리, 부정 이용 방지, 법적 의무 준수</li>
      </ol>
    </li>

    <li>
      <strong>제2조 (수집하는 개인정보의 항목)</strong>
      <ol>
        <li>온길은 서비스 제공을 위해 아래와 같은 개인정보를 수집할 수 있습니다.</li>
        <li>필수 항목: 아이디(ID), 비밀번호, 이메일, 연락처</li>
        <li>선택 항목: 프로필 사진, 주소, 성별, 생년월일</li>
        <li>자동 수집 항목: IP 주소, 쿠키, 서비스 이용 기록, 기기 정보</li>
      </ol>
    </li>

    <li>
      <strong>제3조 (개인정보의 보유 및 이용 기간)</strong>
      <ol>
        <li>온길은 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 즉시 파기합니다.</li>
        <li>단, 관련 법령에 의해 보존이 필요한 경우, 일정 기간 동안 보관 후 파기합니다.</li>
        <li>회원탈퇴 시 개인정보는 30일 이내 파기됩니다.</li>
        <li>전자상거래 관련 기록: 5년 (전자상거래법)</li>
        <li>서비스 이용 기록: 3년 (통신비밀보호법)</li>
      </ol>
    </li>

    <li>
      <strong>제4조 (개인정보 제공 및 위탁)</strong>
      <ol>
        <li>온길은 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다.</li>
        <li>다만, 법령에 따라 요구될 경우 예외적으로 제공될 수 있습니다.</li>
        <li>서비스 운영을 위해 일부 업무를 위탁할 수 있으며, 위탁 시 사전 공지합니다.</li>
      </ol>
    </li>

    <li>
      <strong>제5조 (개인정보의 파기 절차 및 방법)</strong>
      <ol>
        <li>온길은 개인정보의 보유기간이 경과하거나 이용 목적이 달성된 경우, 즉시 파기합니다.</li>
        <li>전자적 파일 형태의 개인정보는 복구 불가능한 방법으로 삭제합니다.</li>
        <li>종이 문서에 기록된 개인정보는 분쇄 또는 소각하여 폐기합니다.</li>
      </ol>
    </li>

    <li>
      <strong>제6조 (이용자의 권리 및 행사 방법)</strong>
      <ol>
        <li>이용자는 언제든지 자신의 개인정보를 열람, 수정, 삭제 요청할 수 있습니다.</li>
        <li>회원 탈퇴 시 개인정보 삭제를 요청할 수 있으며, 온길은 즉시 처리합니다.</li>
        <li>개인정보 관련 문의는 고객센터를 통해 접수할 수 있습니다.</li>
      </ol>
    </li>

    <li>
      <strong>제7조 (개인정보 보호를 위한 조치)</strong>
      <ol>
        <li>온길은 이용자의 개인정보 보호를 위해 기술적, 관리적 보호 조치를 시행합니다.</li>
        <li>데이터 암호화, 방화벽 설치, 접근 권한 관리 등을 통해 개인정보를 보호합니다.</li>
        <li>개인정보 처리 직원의 최소화 및 교육을 통해 보안 강화를 실시합니다.</li>
      </ol>
    </li>

    <li>
      <strong>제8조 (쿠키의 운영 및 활용)</strong>
      <ol>
        <li>온길은 개인 맞춤형 서비스를 제공하기 위해 쿠키를 사용할 수 있습니다.</li>
        <li>이용자는 브라우저 설정을 통해 쿠키 저장을 거부하거나 삭제할 수 있습니다.</li>
      </ol>
    </li>

    <li>
      <strong>제9조 (개인정보 보호책임자)</strong>
      <ol>
        <li>온길은 개인정보 보호를 위해 책임자를 지정하여 운영합니다.</li>
        <li>문의 사항이 있을 경우 개인정보 보호책임자에게 연락할 수 있습니다.</li>
      </ol>
    </li>

    <li>
      <strong>제10조 (개인정보 처리방침 변경)</strong>
      <ol>
        <li>본 개인정보 처리방침은 법령 개정 및 내부 정책 변경에 따라 수정될 수 있습니다.</li>
        <li>변경 내용은 온길 웹사이트를 통해 사전 공지합니다.</li>
      </ol>
    </li>
</ul>
);

export default PersonalDataPolicy;